import { cn } from '@/lib/utils';
import { Instagram, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="w-full py-10 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center space-x-1 mb-4">
              <span className="text-primary font-bold text-xl">Career</span>
              <span className="text-secondary font-bold text-xl">Lens</span>
            </div>
            <p className="text-muted-foreground mb-4 max-w-md">
              Guiding students and young professionals toward future-ready careers through personalized insights and emerging career field analysis.
            </p>
            <div className="flex space-x-4">
              <a href="https://instagram.com/careerlens.ai" className="text-foreground/60 hover:text-primary transition-colors" target="_blank" rel="noopener noreferrer">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="https://x.com/careerlensai" className="text-foreground/60 hover:text-primary transition-colors" target="_blank" rel="noopener noreferrer">
                <Twitter className="h-5 w-5" />
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-foreground tracking-wider uppercase mb-4">Explore</h3>
            <ul className="space-y-2">
              <li>
                <a href="#personality-test" className="text-muted-foreground hover:text-primary transition-colors">
                  Personality Test
                </a>
              </li>
              <li>
                <a href="#future-careers" className="text-muted-foreground hover:text-primary transition-colors">
                  Future Careers
                </a>
              </li>
              <li>
                <a href="#about" className="text-muted-foreground hover:text-primary transition-colors">
                  About Us
                </a>
              </li>
              <li>
                <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                  Resources
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-sm font-semibold text-foreground tracking-wider uppercase mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                  Data Usage
                </a>
              </li>
              <li>
                <a href="#" className="text-muted-foreground hover:text-primary transition-colors">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-12 pt-8 border-t border-gray-200 text-center text-sm text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} CareerLens. All rights reserved.</p>
          <p className="mt-2">Career data is predictive and based on current trends analysis.</p>
          
          <div className="flex flex-col items-center justify-center mt-6">
            <p className="flex flex-col items-center">
              Made with <span className="text-red-500 mx-2">❤️</span> by
              <a 
                href="https://reindent.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center mt-2"
              >
                <img 
                  src="/lovable-uploads/1636017f-b3e0-4a85-8d11-e0ef08978b26.png" 
                  alt="Reindent Logo" 
                  className="h-7" 
                />
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
